import { AddIcon } from "@chakra-ui/icons";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Portal,
  useDisclosure,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  MenuButtonProps,
} from "@chakra-ui/react";
import { PathId } from "features/Path/models";
import React, { useCallback, useState } from "react";
import NewTemplateForm from "features/Resources/Shared/Components/Form/NewTemplateForm";
import { PrimaryButtonWithRef } from "components/Button";
import AddTemplatesToPathByList from "features/Resources/SharedTemplate/Components/AddTemplatesToPathByList";
import { FiFilePlus } from "react-icons/fi";

interface AddNewTemplateToPathButtonProps {
  pathId: PathId;
  menuButtonProps: MenuButtonProps;
}

export default function AddNewTemplateToPathButton({
  pathId,
  menuButtonProps = {},
  ...props
}: AddNewTemplateToPathButtonProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [templateForm, setTemplateForm] = useState<"new_template" | "add_template" | null>(null);
  const initialRef = React.useRef(null);

  const onAddTemplate = useCallback(
    (innerTemplateForm: "new_template" | "add_template") => {
      setTemplateForm(innerTemplateForm);
      onOpen();
    },
    [setTemplateForm, onOpen],
  );

  return (
    <>
      <Menu {...props}>
        <MenuButton as={PrimaryButtonWithRef} aria-label="Add to schedule" leftIcon={<AddIcon boxSize={3} />} {...menuButtonProps}>
          Add
        </MenuButton>
        <Portal>
          <MenuList>
            <MenuItem onClick={() => onAddTemplate("new_template")} icon={<AddIcon />}>
              New template
            </MenuItem>
            <MenuItem onClick={() => onAddTemplate("add_template")} icon={<FiFilePlus />}>
              Existing template
            </MenuItem>
          </MenuList>
        </Portal>
      </Menu>
      <Modal
        initialFocusRef={initialRef}
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        size={templateForm === "new_template" ? "sm" : "5xl"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{templateForm === "new_template" ? "New template" : "Add existing template"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            {templateForm === "new_template" ? (
              <NewTemplateForm pathId={pathId} />
            ) : templateForm === "add_template" ? (
              <AddTemplatesToPathByList pathId={pathId} />
            ) : null}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
